import StringHelper from '../utils/string';

export function subdomainUrl(subdomain, path) {
  if (typeof path === 'undefined') {
    return `${window.location.protocol}//${subdomain}.${process.env.MIX_ROOT_DOMAIN}`;
  }

  path = StringHelper.leftTrim(path, '/');

  return `${window.location.protocol}//${subdomain}.${process.env.MIX_ROOT_DOMAIN}/${path}`;
}

export function url(path) {
  if (typeof path === 'undefined') {
    return `${window.location.protocol}//www.${process.env.MIX_ROOT_DOMAIN}`;
  }

  path = StringHelper.leftTrim(path, '/');

  return `${window.location.protocol}//www.${process.env.MIX_ROOT_DOMAIN}/${path}`;
}
